export default "https://cdn-static.gokick.com/assets/0488227f5b7e53bbf90738be35137ce008cd4a94/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";